import React, { Component } from 'react'
import Titulo from '../comum/Titulo'
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import EmissaoMdfe from './EmissaoMdfe';
import { withRouter } from 'react-router-dom';
import buscarEmissoesMdfe from '../../actions/mdfe/buscarEmissoesMdfe';
import selecionarEmissaoMdfe from '../../actions/mdfe/selecionarEmissaoMdfe';
import transmitirEmissaoMdfe from '../../actions/mdfe/transmitirEmissaoMdfe';
import cancelarMdfe from '../../actions/mdfe/cancelarMdfe';
import encerrarMdfe from '../../actions/mdfe/encerrarMdfe';
import { showSuccessMsg } from '../../util/messagesUtil';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import BotoesPaginacaoMdfe from './BotoesPaginacaoMdfe';
import PaginacaoMdfe from './PaginacaoMdfe';
import determinarPaginaAtualMdfe from '../../actions/mdfe/determinarPaginaAtualMdfe';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import PainelFiltrosMdfe from './PainelFiltrosMdfe';

const ModalConfirmacaoTransmissaoMdfe = ({ transmitir, limpar }) => (
    <div className="modal fade" id="modalConfirmacaoTransmissaoMdfe" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacaoMdfe" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons">send</span>
                        Transmitir MDF-e
                    </div>
                    <button type="button" className="vx-modal-close" data-dismiss="modal"
                            aria-label="Fechar" onClick={limpar}>
                        <span className="material-icons">close</span>
                    </button>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#444' }}>
                        Deseja transmitir o MDF-e selecionado?
                    </p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                            onClick={limpar}>Cancelar</button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                            onClick={transmitir}>
                        <span className="material-icons" style={{ fontSize: 15 }}>send</span>
                        Transmitir
                    </button>
                </div>
            </div>
        </div>
    </div>
);

const ModalCancelamentoMdfe = ({ cancelar, limpar, justificativa, onChangeJustificativa }) => (
    <div className="modal fade" id="modalCancelamentoMdfe" tabIndex="-1" role="dialog"
         aria-labelledby="modalCancelamentoMdfe" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons">delete</span>
                        Cancelar MDF-e
                    </div>
                    <button type="button" className="vx-modal-close" data-dismiss="modal"
                            aria-label="Fechar" onClick={limpar}>
                        <span className="material-icons">close</span>
                    </button>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff' }}>
                    <div className="vx-modal-section">
                        <p style={{ margin: '0 0 12px', fontSize: 14, color: '#444' }}>
                            Tem certeza que deseja cancelar o MDF-e selecionado?
                        </p>
                        <div className="vx-modal-section-title">
                            <span className="material-icons">description</span>
                            Justificativa <small style={{ fontWeight: 400, color: '#aaa', marginLeft: 4 }}>(15 a 245 caracteres)</small>
                        </div>
                        <textarea
                            className="vx-config-textarea"
                            rows="3"
                            minLength={15}
                            maxLength={245}
                            value={justificativa}
                            onChange={(e) => onChangeJustificativa(e.target.value)}
                            placeholder="Informe o motivo do cancelamento..."
                        />
                        <div style={{ fontSize: 11, color: '#aaa', marginTop: 4, textAlign: 'right' }}>
                            {justificativa.length}/245 caracteres
                        </div>
                    </div>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                            onClick={limpar}>Não</button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                            disabled={justificativa.length < 15}
                            onClick={cancelar}>
                        <span className="material-icons" style={{ fontSize: 15 }}>delete</span>
                        Sim, cancelar
                    </button>
                </div>
            </div>
        </div>
    </div>
);

const ModalEncerramentoMdfe = ({ encerrar, limpar }) => (
    <div className="modal fade" id="modalEncerramentoMdfe" tabIndex="-1" role="dialog"
         aria-labelledby="modalEncerramentoMdfe" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons">check_circle</span>
                        Encerrar MDF-e
                    </div>
                    <button type="button" className="vx-modal-close" data-dismiss="modal"
                            aria-label="Fechar" onClick={limpar}>
                        <span className="material-icons">close</span>
                    </button>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#444' }}>
                        Deseja encerrar o MDF-e selecionado?
                    </p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                            onClick={limpar}>Não</button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                            onClick={encerrar}>
                        <span className="material-icons" style={{ fontSize: 15 }}>check_circle</span>
                        Sim, encerrar
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export const CabecalhoTabela = () => (
    <div className="vx-list-header vx-list-header--mdfe">
        <div className="vx-list-header-cell">Id</div>
        <div className="vx-list-header-cell">Data de Emissão</div>
        <div className="vx-list-header-cell">Placa</div>
        <div className="vx-list-header-cell">UF Inicial / Final</div>
        <div className="vx-list-header-cell">Valor Total</div>
        <div className="vx-list-header-cell">Qtd CT-es</div>
        <div className="vx-list-header-cell">Status MDF-e</div>
        <div className="vx-list-header-cell">Status Evento</div>
        <div className="vx-list-header-cell">Ações</div>
    </div>
);

export class PainelGerenciarEmissaoMdfe extends Component {

    constructor(props) {
        super(props);
        this.state = {
            justificativaCancelamento: ''
        }
    }

    UNSAFE_componentWillMount() {
        this.props.determinarPaginaAtualMdfe(1)
    }

    componentDidMount() {
        this.props.selecionarEmissaoMdfe(null);
        this.buscarEmissoesMdfe();
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.buscarEmissoesMdfe();
            }
        }
        if (alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.buscarEmissoesMdfe();
        }
    }

    buscarEmissoesMdfe() {
        this.props.buscarEmissoesMdfe(
            this.props.empresaSelecionada.id,
            this.props.paginaAtual,
            this.props.registrosPorPagina,
            this.props.filtrosAdicionados
        );
    }

    limparSelecao() {
        this.props.selecionarEmissaoMdfe(null);
        this.setState({ justificativaCancelamento: '' });
    }

    transmitirMdfe() {
        this.props.transmitirEmissaoMdfe(this.props.emissaoMdfeSelecionada.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Transmissão do MDF-e iniciada!');
                this.limparSelecao();
                this.buscarEmissoesMdfe();
            });
    }

    cancelarMdfe() {
        this.props.cancelarMdfe(
            this.props.emissaoMdfeSelecionada.id,
            this.props.empresaSelecionada.id,
            this.state.justificativaCancelamento
        ).then(() => {
            showSuccessMsg('Cancelamento do MDF-e iniciado!');
            this.limparSelecao();
            this.buscarEmissoesMdfe();
        });
    }

    encerrarMdfe() {
        this.props.encerrarMdfe(this.props.emissaoMdfeSelecionada.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Encerramento do MDF-e iniciado!');
                this.limparSelecao();
                this.buscarEmissoesMdfe();
            });
    }

    exibirTabelaEmissaoMdfe() {
        return (
            <div className="vx-list-container">
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoMdfe}
                                       BotoesPaginacao={BotoesPaginacaoMdfe}
                                       emissoesMdfe={this.props.emissoesMdfe}
                                       empresaSelecionada={this.props.empresaSelecionada}>
                    {this.props.emissoesMdfe && this.props.emissoesMdfe.length > 0 && <CabecalhoTabela />}
                    {(!this.props.emissoesMdfe || this.props.emissoesMdfe.length === 0)
                        ? <div className="vx-empty-state">
                            <span className="material-icons">description</span>
                            <p>Nenhuma emissão de MDF-e.</p>
                          </div>
                        : this.props.emissoesMdfe.map(it =>
                            <EmissaoMdfe key={`emissaoMdfe-${it.id}`} mdfe={it} />
                          )
                    }
                </CabecalhoRodapeTabela>
            </div>
        )
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                <div className="row internas">
                    <Titulo texto="Transmissão MDF-e" urlRetorno="/menu-encomendas" />
                    <div className="col-12" style={{ marginBottom: 12 }}>
                        <PainelFiltrosMdfe />
                    </div>
                    <div className="col-12" style={{ marginBottom: 16 }}>
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                            getGestorEmpresa(this.props.empresaSelecionada.id),
                            getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                            <button className="vx-toolbar-btn"
                                onClick={() => {
                                    this.limparSelecao();
                                    this.props.history.push('/painel-cadastro-mdfe');
                                }}>
                                <span className="material-icons">add</span>
                                Criar Novo MDF-e
                            </button>
                        </Autorizacao>
                    </div>
                    <div className="col-12">
                        {this.exibirTabelaEmissaoMdfe()}
                    </div>
                </div>

                <ModalConfirmacaoTransmissaoMdfe
                    transmitir={this.transmitirMdfe.bind(this)}
                    limpar={this.limparSelecao.bind(this)} />

                <ModalCancelamentoMdfe
                    cancelar={this.cancelarMdfe.bind(this)}
                    limpar={this.limparSelecao.bind(this)}
                    justificativa={this.state.justificativaCancelamento}
                    onChangeJustificativa={(v) => this.setState({ justificativaCancelamento: v })} />

                <ModalEncerramentoMdfe
                    encerrar={this.encerrarMdfe.bind(this)}
                    limpar={this.limparSelecao.bind(this)} />
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => ({
    empresaSelecionada: state.empresaSelecionada,
    emissoesMdfe: state.emissoesMdfe.emissoesMDFe,
    emissaoMdfeSelecionada: state.emissaoMdfeSelecionada,
    paginaAtual: state.paginaAtualMdfe,
    registrosPorPagina: state.registrosPorPaginaMdfe,
    filtrosAdicionados: state.filtrosAdicionadosMdfe
})

export default withRouter(connect(mapStateToProps, {
    buscarEmissoesMdfe,
    selecionarEmissaoMdfe,
    transmitirEmissaoMdfe,
    cancelarMdfe,
    encerrarMdfe,
    determinarPaginaAtualMdfe
})(reduxForm({
    form: 'formularioPainelMdfe'
})(PainelGerenciarEmissaoMdfe)));
